import * as React from 'react';
import LexiconLanguage from '../new/lexicons/LexiconLanguage';
import LexiconStemMatch from '../new/lexicons/LexiconStemMatch';
import './LexiconSearchResultItem.css';

interface Props {
    match: LexiconStemMatch;
    onClick: (match: LexiconStemMatch) => void;
}

export default class LexiconSearchResultItem extends React.Component<Props> {

    public constructor(props: Props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    public render() {
        const match = this.props.match;
        const classes = ['LexiconSearchResultItem', match.getLanguage() === LexiconLanguage.Hebrew ? '_Hebrew' : '_Greek'];
        return (
            <div className={classes.join(' ')} onClick={this.onClick}>
                {match.getText()}
            </div>
        );
    }

    private onClick() {
        this.props.onClick(this.props.match);
    }
}
